import { render, staticRenderFns } from "./CprClaimsFileFeed.vue?vue&type=template&id=58760f55"
import script from "./CprClaimsFileFeed.vue?vue&type=script&lang=js"
export * from "./CprClaimsFileFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports